import React, { useEffect, useState } from 'react'
import styles from './Dashboard.module.css'
import TextField from '@material-ui/core/TextField';
import SearchBox from '../SearchBox/SearchBox'
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import TypeDropdown from '../../TypeDropdown/TypeDropdown';
import { useStateValue } from '../../StateProvider';
import { useHistory } from "react-router-dom";
import axios from '../../axios';

function Dashboard() {

    let history = useHistory();

    const [{loginInfo,loggedIn}, dispatch] = useStateValue()

    const [filterCity,setFilterCity] = useState('')
    const [filterState,setFilterState] = useState('')
    const [selectedResource,setSelectedResource] = useState('')

    const [tab,setTab] = useState(true)

    const [orgName,setOrgName] = useState('')
    const [personnel,setPersonnel] = useState('')
    const [contact,setContact] = useState('')
    const [units,setUnits] = useState('')
    const [address,setAddress] = useState('')
    const [message,setMessage] = useState('')
    const [resourceClass,setResourceClass] = useState('')

    const [requestContact,setRequestContact] = useState('')

    const postRequest = async () =>{
        if((filterState === "Andaman and Nicobar island (UT)") | ( filterState==="Ladakh (UT)") ){
            if((requestContact.length===10) && (message.length<=80)){
                if(selectedResource.toLowerCase() === 'plasma'){

                    axios.post('/updateRequests/makeRequest',{
                        name:loginInfo.profileObj.name,
                        resourceType: selectedResource.toLowerCase(),
                        contact: requestContact,
                        email:loginInfo.profileObj.email,
                        message:message,
                        state: filterState,
                        district:filterCity,
                        bloodType: resourceClass,
                    }).then((response)=>{
                        alert(response.data.message)
                    }).catch(error=>alert(error.response))
                }
                else if(selectedResource.toLowerCase() === 'food'){
                    await axios.post('/updateRequests/makeRequest',{
                        name:loginInfo.profileObj.name,
                        resourceType: selectedResource.toLowerCase(),
                        contact: requestContact,
                        email:loginInfo.profileObj.email,
                        message:message,
                        state: filterState,
                        district:filterCity,
                        foodType: resourceClass,
                    }).then((response)=>{
                        alert(response.data.message)
                    }).catch(error=>alert(error.response))
                }
                else{
                    axios.post('/updateRequests/makeRequest',{
                        name:loginInfo.profileObj.name,
                        resourceType: selectedResource.toLowerCase(),
                        contact: requestContact,
                        email:loginInfo.profileObj.email,
                        message:message,
                        state: filterState,
                        district:filterCity,
                    }).then((response)=>{
                        alert(response.data.message)
                    }).catch(error=>alert(error.response))
                }
            }else{
                alert("Please add valid mobile number and message should be less that 60 letters")
            }
        }else{
            if( filterCity){
            if((requestContact.length===10) && (message.length<=80)){
                if(selectedResource.toLowerCase() === 'plasma'){

                    axios.post('/updateRequests/makeRequest',{
                        name:loginInfo.profileObj.name,
                        resourceType: selectedResource.toLowerCase(),
                        contact: requestContact,
                        email:loginInfo.profileObj.email,
                        message:message,
                        state: filterState,
                        district:filterCity,
                        bloodType: resourceClass,
                    }).then((response)=>{
                        alert(response.data.message)
                    }).catch(error=>alert(error.response))
                }
                else if(selectedResource.toLowerCase() === 'food'){
                    await axios.post('/updateRequests/makeRequest',{
                        name:loginInfo.profileObj.name,
                        resourceType: selectedResource.toLowerCase(),
                        contact: requestContact,
                        email:loginInfo.profileObj.email,
                        message:message,
                        state: filterState,
                        district:filterCity,
                        foodType: resourceClass,
                    }).then((response)=>{
                        alert(response.data.message)
                    }).catch(error=>alert(error.response))
                }
                else{
                    axios.post('/updateRequests/makeRequest',{
                        name:loginInfo.profileObj.name,
                        resourceType: selectedResource.toLowerCase(),
                        contact: requestContact,
                        email:loginInfo.profileObj.email,
                        message:message,
                        state: filterState,
                        district:filterCity,
                    }).then((response)=>{
                        alert(response.data.message)
                    }).catch(error=>alert(error.response))
                }
            }else{
                alert("Please add valid mobile number and message should be less that 60 letters")
            }
        }else{
            alert("Please select a valid city")
        }
    }
        

    }

    const postResource = async () =>{
        
    if( (filterState === "Andaman and Nicobar island (UT)") | ( filterState==="Ladakh (UT)")){
        if((contact.length===10) && (address.length<=50)){
        if(selectedResource.toLowerCase() === 'plasma'){
            axios.post('/updateResources/addNewResource',{
                orgName: orgName, 
                personnelName: personnel, 
                address: address, 
                contactNumber: contact, 
                state: filterState, 
                city: filterCity, 
                units: units,
                type: selectedResource.toLowerCase(),
                bloodType:resourceClass,
                addedByName:loginInfo.profileObj.name,
                addedByEmail:loginInfo.profileObj.email,
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
        else if(selectedResource.toLowerCase() === 'food'){
            await axios.post('/updateResources/addNewResource',{
                orgName: orgName, 
                personnelName: personnel, 
                address: address, 
                contactNumber: contact, 
                state: filterState, 
                city: filterCity, 
                type: selectedResource.toLowerCase(),
                foodType:resourceClass,
                addedByName:loginInfo.profileObj.name,
                addedByEmail:loginInfo.profileObj.email,
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
        else{

            axios.post('/updateResources/addNewResource',{
                orgName: orgName, 
                personnelName: personnel, 
                address: address, 
                contactNumber: contact, 
                state: filterState, 
                city: filterCity, 
                units: units,
                type: selectedResource.toLowerCase(),
                addedByName:loginInfo.profileObj.name,
                addedByEmail:loginInfo.profileObj.email,
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
    }else{
        alert("Please add valid mobile number and address should be less that 40 letters")
    }
    }
   else{
            if(filterCity){
        if((contact.length===10) && (address.length<=50)){
        if(selectedResource.toLowerCase() === 'plasma'){
            axios.post('/updateResources/addNewResource',{
                orgName: orgName, 
                personnelName: personnel, 
                address: address, 
                contactNumber: contact, 
                state: filterState, 
                city: filterCity, 
                units: units,
                type: selectedResource.toLowerCase(),
                bloodType:resourceClass,
                addedByName:loginInfo.profileObj.name,
                addedByEmail:loginInfo.profileObj.email,
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
        else if(selectedResource.toLowerCase() === 'food'){
            await axios.post('/updateResources/addNewResource',{
                orgName: orgName, 
                personnelName: personnel, 
                address: address, 
                contactNumber: contact, 
                state: filterState, 
                city: filterCity, 
                type: selectedResource.toLowerCase(),
                foodType:resourceClass,
                addedByName:loginInfo.profileObj.name,
                addedByEmail:loginInfo.profileObj.email,
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
        else{
            axios.post('/updateResources/addNewResource',{
                orgName: orgName, 
                personnelName: personnel, 
                address: address, 
                contactNumber: contact, 
                state: filterState, 
                city: filterCity, 
                units: units,
                type: selectedResource.toLowerCase(),
                addedByName:loginInfo.profileObj.name,
                addedByEmail:loginInfo.profileObj.email,
            }).then((response)=>{
                alert(response.data.message)
            }).catch(error=>alert(error.response))
        }
    }else{
        alert("Please add valid mobile number and address should be less that 40 letters")
    }}
    else{
        alert("Please select a valid city")
    }
}

    }

    const logoutUser = () =>{

            dispatch({
                type: 'LOGOUT_USER',
                userData: {},
            })

            history.push('/login')
          
    }

    useEffect(() => {
        if(loggedIn){
            console.log('')
        }
        else{
            history.push('/login')
        }
    }, [])  
    


    return (
        <div className={styles.component}>

            
            <form className={styles.form} noValidate autoComplete="off">

            <div className={styles.tabs}>

                <Button
                    variant="contained" 
                    size="large" 
                    color={tab ? "secondary" : ""}
                    className={styles.tabBtn} 
                    style={{marginTop:'15px'}} 
                    onClick={()=>setTab(true)}
                >
                    New Resource
                </Button>

                <Button
                    variant="contained"
                    size="large"
                    color={!tab ? "secondary" : ""}
                    className={styles.tabBtn}
                    style={{marginTop:'15px'}}
                    onClick={()=>setTab(false)}
                >
                    New Request
                </Button>
                
            </div>

                <div className={styles.title}>{ tab ? "New resource entry form" : "New request entry form"}</div>

                <div className={styles.formInner}>
                    { (tab) ? ( <>
                        <TextField id="outlined-basic" label="Organisation Name" variant="outlined" className={styles.addSpacing} value={orgName} onChange={(e)=> setOrgName(e.target.value)}/>
                    <TextField id="outlined-basic" label="Personnel Name" variant="outlined" className={styles.addSpacing} value={personnel} onChange={(e)=> setPersonnel(e.target.value)}/>
                    <TextField id="outlined-basic" label="Personnel Contact" variant="outlined" value={contact} className={styles.addSpacing} onChange={(e)=> setContact(e.target.value)}/>
                    <div className={styles.addSpacing}/>

                    <TypeDropdown setSelectedResource={setSelectedResource} className={styles.addSpacing} setResourceClass={setResourceClass}/>

                   
                    {(selectedResource?.toLowerCase() === 'food' | selectedResource?.toLowerCase() === 'plasma') ?   (<div className={styles.addSpacing}/>) : null}

                    {(selectedResource?.toLowerCase() === 'food') ? <TypeDropdown setResourceClass={setResourceClass} value={resourceClass} className={styles.addSpacing} Food/> : (selectedResource?.toLowerCase() === 'plasma') ? <TypeDropdown value={resourceClass} setResourceClass={setResourceClass} className={styles.addSpacing} Plasma/> : null}

                    {(selectedResource?.toLowerCase() !== 'food') ?(
                    <TextField
                        label="Units Available"
                        id="outlined-start-adornment"
                        type="number"
                        InputProps={{
                            endAdornment: <InputAdornment position="start">Units</InputAdornment>,
                        }}
                        variant="outlined"
                        className={styles.addSpacing}
                        value={units}
                        onChange={(e)=> setUnits(e.target.value)}
                        
                    />): null}
                    <TextField id="outlined-basic" label="Address" variant="outlined" className={styles.addSpacing} value={address} onChange={(e)=> setAddress(e.target.value)}/>

                    <div className={styles.addSpacing}/>
                    <SearchBox setFilterCity={setFilterCity} setFilterState={setFilterState}/>
                        <TextField id="outlined-basic" label="My email" variant="outlined" value={loginInfo?.profileObj?.email} className={styles.addSpacing} disabled />
                        <TextField id="outlined-basic" label="My Profile Name" variant="outlined" value={loginInfo?.profileObj?.name} className={styles.addSpacing} disabled />

                        <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={styles.addResources}
                        style={{marginTop:'15px'}}
                        disabled={!orgName | !contact | !personnel | !address | !selectedResource | !filterState}
                        onClick={postResource}
                        >
                            Add Resource
                        </Button> </>) : (


                            <>
                            <TextField disabled id="outlined-basic" label="Name" variant="outlined" className={styles.addSpacing} value={loginInfo.profileObj.name}/>
                            <TextField disabled id="outlined-basic" label="Email" variant="outlined" value={loginInfo.profileObj.email} className={styles.addSpacing} />
                            <TextField id="outlined-basic" label="Contact" variant="outlined" value={requestContact} className={styles.addSpacing} onChange={(e)=> setRequestContact(e.target.value)}/>
                            
                        <div className={styles.addSpacing}/>
    
                        <TypeDropdown setSelectedResource={setSelectedResource} setResourceClass={setResourceClass} className={styles.addSpacing}/>
    
                       
                        {(selectedResource?.toLowerCase() === 'food' | selectedResource?.toLowerCase() === 'plasma') ?   (<div className={styles.addSpacing}/>) : null}
    
                        {(selectedResource?.toLowerCase() === 'food') ? <TypeDropdown setResourceClass={setResourceClass} value={resourceClass} className={styles.addSpacing} Food/> : (selectedResource?.toLowerCase() === 'plasma') ? <TypeDropdown value={resourceClass} setResourceClass={setResourceClass} className={styles.addSpacing} Plasma/> : null}
    
                        
                        <TextField id="outlined-basic" label="Message" variant="outlined" className={styles.addSpacing} multiline rows={3} value={message} onChange={(e)=> setMessage(e.target.value)}/>
    
                        <div className={styles.addSpacing}/>
                        <SearchBox setFilterCity={setFilterCity} setFilterState={setFilterState}/>
                            
    
                            <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={styles.addResources}
                            style={{marginTop:'15px'}}
                            disabled={ !requestContact | !message | !selectedResource | !filterState}

                            onClick={postRequest}
                            >
                                Post Request
                            </Button> </>
                            

                        )
                    }
                </div>

                <div className={styles.logoutBtn}>
                <Button
                variant="contained"
                color="secondary"
                size="small"
                className={styles.addResources}
                style={{marginTop:'45px'}}
                onClick={logoutUser}
            >
                Logout User
            </Button> 
            </div>
                
            </form>

            
        </div>
    )
}

export default Dashboard
